// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"c7","header":"c8","message":"c9","copyMessage":"c-","button":"c_"};